import modelExtend from 'dva-model-extend'
import {delay, pageModel} from './common'
import pathToRegexp from "path-to-regexp"
import service from '../services/ticket'
import * as routerRedux from "react-router-redux"

export default modelExtend(pageModel, {

  namespace: 'ticketorder',
  state: {
    orderInfo: {}
  },
  subscriptions: {
    setupHistory({dispatch, history}) {
      history.listen((location) => {
        let [path, orderId] = pathToRegexp('/ticket/order/:orderId').exec(location.pathname) || []
        if (orderId) {
          dispatch({
            type: 'init',
            payload: orderId,
          })
        } else {
        }
      })
    },
  },
  effects: {
    * init({payload,}, {call, put, select}) {
      const orderInfo = yield call(service.getTicketOrder, payload)
      yield put({
        type: 'updateState',
        payload: {
          orderInfo
        }
      })
      if(orderInfo && orderInfo.status === 0) {
        yield put(routerRedux.replace('/ticket'))
      }
    },
  },
  reducers: {
    showModal(state, {payload}) {
      return {
        ...state, ...payload,
        modalVisible: true,
      }
    },
    hideModal(state) {
      return {
        ...state,
        modalVisible: false,
      }
    },
  },
})
